import { atomFamily } from "jotai/utils";

import { createDerivedSessionAtom } from "./utils/createDerivedSessionAtom";
import { createPersistedAtom } from "./utils/createPersistedAtom";

export const sessionAdditionalDetailsAtom = atomFamily((sessionId: string) =>
  createPersistedAtom(`additionalDetails-${sessionId}`, "")
);
export const additionalDetailsAtom = createDerivedSessionAtom<string>(sessionAdditionalDetailsAtom);
